module.exports = __webpack_public_path__ + "img/formador-30.25723780.png";